import React from 'react'
import Text from '@component/Text/Text'

export const PointTermEnglish = () => {
    return (
        <>
            <div className={'layout-desktop default_page_padding text-body2 text-gray02 dark:text-dark_gray02'}>
                <Text>Date: 2024.06.03</Text>
                <Text className={'mt-[10px]'}>Enforcement date: 2024.06.03</Text>
                <Text className={'text-ti1  mt-[20px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 1 (Object)
                </Text>
                <Text className={'mt-[10px]'}>
                    The purpose of this standard is to specify all aspects of the use, exchange, or expiration of the
                    various points provided by the League of Traders (hereinafter referred to as &quot;service&quot;) or
                    its affiliates (hereinafter referred to as the &quot;alliance&quot;).
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 2 (Definitions of Terms)
                </Text>
                <Text className={'mt-[10px]'}>The terms used in this standard are defined as follows:</Text>
                <Text className={'mt-[10px]'}>
                    ① point is the value that a member (hereinafter referred to as a &quot;member&quot; or
                    &quot;members&quot;) who created and subscribed to League of Traders can accumulate and use the
                    account in &quot;service&quot; and &quot;alliance&quot;, and the type shall be according to the
                    following.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'mt-[10px]'}>
                        A. &quot;Point&quot; refers to the value generated or transmitted through which
                        &quot;members&quot; earn points from the service, or are accrued as benefits through functions
                        within the &quot;service&quot;.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        B. &quot;Unrefundable point&quot; refers to &quot;points&quot; that cannot be refunded for
                        non-title event purposes, and can be arbitrarily extinguished after a certain time.
                    </Text>
                </div>
                <Text className={'mt-[10px]'}>
                    ② Terminology not set out in this standard shall comply with the terms and conditions of the
                    &quot;Service&quot;.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 3 (Application target)
                </Text>
                <Text className={'mt-[10px]'}>
                    This standard applies to &quot;members&quot; who have registered and subscribed to accounts through
                    League of Traders &quot;Service&quot;.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 4 (set aside points)
                </Text>
                <Text className={'mt-[10px]'}>
                    &quot;Members&quot; may earn certain points depending on the use of the functions within the
                    &quot;Service&quot;.
                </Text>
                <Text className={'mt-[10px]'}>
                    ① For the &quot;Challenge&quot; function within the &quot;Service&quot; at present, 70% of the
                    points paid within the &quot;Service&quot; can be earned by the use of &quot;Members&quot;. In this
                    case, the &quot;challenge&quot; function is completed 72 hours later, and the points on which the
                    refund is applied are excluded.
                </Text>
                <Text className={'mt-[10px]'}>
                    ① You can check the &quot;Points&quot; reserves that are not set out in paragraph 1 through the
                    &quot;Service&quot; website or mobile application.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 5 (how points are used)
                </Text>
                <Text className={'mt-[10px]'}>The terms used in this standard are defined as follows:</Text>
                <Text className={'mt-[10px]'}>
                    ① The use method for each type of &quot;point&quot; shall be as specified in the following
                    subparagraph.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'mt-[10px]'}>
                        (1) Points can be used to activate paid functions of &quot;exchange&quot; among functions within
                        &quot;service&quot;.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        (2) Points can be used to activate paid functions of &quot;subscribe&quot; among functions
                        within &quot;service&quot;.
                    </Text>
                </div>
                <Text className={'mt-[10px]'}>
                    ② You can check the use of the &quot;Point&quot; specified in paragraph 1 on the &quot;Service&quot;
                    website or mobile application.
                </Text>
                <Text className={'mt-[10px]'}>
                    ③ The ranking of deduction based on the use of the earned &quot;points&quot; is based on the order
                    of the accumulated dates. However, if &quot;service&quot; is otherwise determined and directed, we
                    will follow suit.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 6 (exchange of points)
                </Text>
                <Text className={'mt-[10px]'}>
                    &quot;Members&quot; are points accumulated within &quot;service&quot;
                </Text>
                <Text className={'mt-[10px]'}>
                    ① Accumulated points can be redeemed within the &quot;service&quot; for coupons or tokens, among
                    other items. Products eligible for redemption will be notified through a separate page.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 7 (restrictions on the use of points, etc.)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① &quot;Points&quot; are not subject to transfer and are not compatible or combined with other types
                    of points. However, if &quot;service&quot; is decided differently and guided through the
                    service&apos;s homepage or mobile application, we will follow the instructions provided.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 8 (Decimation of &quot;Points&quot;)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① &quot;Points&quot; may be used within the expiration date specified in each of the following
                    subparagraphs, and expired points will automatically expire in monthly units.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text>
                        (1) The expiration date of &quot;Point&quot; is two years from the date of installment, and if a
                        member leaves, it may expire immediately.
                    </Text>
                </div>
                <Text className={'mt-[10px]'}>
                    ② Notwithstanding paragraph 1, the earned &quot;point&quot; will automatically expire if the
                    &quot;member&quot; corresponds to 1 of each of the following: However, in the case of No. 1 or No.
                    3, only the &quot;points&quot; accumulated shall be covered.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    <Text className={'mt-[10px]'}>
                        (1) In the event that an application for admission was illegally issued through false or
                        son-in-law or other means.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        (2) In case &quot;service&quot; is used for unhealthy purposes disguised as buying goods
                    </Text>
                    <Text className={'mt-[10px]'}>
                        (3) In case &quot;service&quot; is used by means of theft, forgery, etc.
                    </Text>
                    <Text className={'mt-[10px]'}>
                        (4) In case the information in &quot;members&quot; is deleted at the request of the law or
                        &quot;members&quot;
                    </Text>
                    <Text className={'mt-[10px]'}>
                        (5) In the event of abuse of other &quot;service&quot; errors or non-common circumstances.
                    </Text>
                </div>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 9 (Change of Standards)
                </Text>
                <Text className={'mt-[10px]'}>
                    ① If you change these terms and conditions, notify the website or mobile application of the changes.
                </Text>
                <Text className={'mt-[10px]'}>
                    ② In the case of subparagraphs, if the member does not express his intention to leave the member
                    within one month from the date of notification, the member shall notify by specifying that he or she
                    agrees to change the change.
                </Text>
                <Text className={'mt-[10px]'}>
                    ③ If the member does not raise an objection by the scheduled date, the changed agreement shall be
                    considered to be approved.
                </Text>
                <Text className={'text-ti1  mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    Article 10 (Compliance Rules)
                </Text>
                <Text className={'mt-[10px]'}>
                    Items not set out in this standard shall be subject to the relevant statutes, the standard terms and
                    conditions of the members and their correlation.
                </Text>
            </div>
        </>
    )
}
